import React from 'react';

const BaseField = ({ field, children }) => {
  const fieldWidth =
    field.width === '50%' ? 'calc(50% - 8px)' : field.width || '100%';

  return (
    <div
      style={{
        width: fieldWidth,
        marginBottom: '0px',
        boxSizing: 'border-box',
        minWidth: field.width === '50%' ? '250px' : 'auto',
      }}
    >
      {children}
    </div>
  );
};

export default BaseField;
